module.exports = __webpack_public_path__ + "static/media/s_figure_skating.4f2c440e.mp3";